// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const silverRock = defineModel({
  id: "silver-rock",
  batchId: "future",
  name: "Silver rock",
  tags: ["scenery","silver","rock","low-poly","age-of-mcp","future"],
  summary: "Silver-bearing ore. Refined for coin, tableware and fine trade goods.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.43,
  parts: () => [
      { geometry: new THREE.IcosahedronGeometry(0.3, 0), color: "#4b4e55", position: [-0.08, 0.22, 0], rotation: [0.06, 0.4, 0.12], scale: [1.05, 1.05, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.2, 0), color: "#42454b", position: [0.2, 0.16, 0.06], rotation: [0.1, 1.3, -0.15], scale: [0.95, 0.95, 0.95] },
      { geometry: new THREE.TetrahedronGeometry(0.15, 0), color: "#565960", position: [0, 0.36, -0.08], rotation: [0.3, 0.8, 0.2] },
      { geometry: new THREE.TetrahedronGeometry(0.08, 0), color: "#d8dde3", position: [0.02, 0.14, 0.12], rotation: [0.3, 0.4, 0.2], scale: [1, 1.3, 0.8] },
      { geometry: new THREE.TetrahedronGeometry(0.075, 0), color: "#eef1f5", position: [-0.03, 0.26, 0.14], rotation: [0.5, 1.2, 0.3], scale: [1, 1.3, 0.8] },
      { geometry: new THREE.TetrahedronGeometry(0.065, 0), color: "#aeb4bd", position: [0.05, 0.34, 0.08], rotation: [0.2, 2, 0.4], scale: [1, 1.3, 0.8] },
      { geometry: new THREE.TetrahedronGeometry(0.06, 0), color: "#d8dde3", position: [-0.12, 0.3, 0.1], rotation: [0.4, 0.6, 0.5], scale: [1, 1.2, 0.8] },
      { geometry: new THREE.ConeGeometry(0.04, 0.16, 5), color: "#eef1f5", position: [0.06, 0.46, 0], rotation: [0.15, 0, -0.1] },
      { geometry: new THREE.ConeGeometry(0.03, 0.12, 5), color: "#d8dde3", position: [-0.06, 0.44, 0.06], rotation: [0.1, 0, 0.25] },
      { geometry: new THREE.ConeGeometry(0.028, 0.1, 5), color: "#aeb4bd", position: [0.14, 0.4, -0.04], rotation: [0.2, 0, -0.3] },
      { geometry: new THREE.TetrahedronGeometry(0.06, 0), color: "#aeb4bd", position: [0.18, 0.04, 0.1], rotation: [0.3, 0.8, 0.2] },
      { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#565960", position: [-0.17, 0.04, -0.09], rotation: [0.2, 1, 0.3], scale: [1.1, 0.7, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#4b4e55", position: [0.05, 0.03, -0.18], rotation: [0.2, 0.4, 0.2], scale: [1.1, 0.7, 1] },
    ],
  animations: [],
});
